import PageLockScreen from "./components/LockScreen";

export default PageLockScreen;
